import * as React from 'react';
import CallbackHelpers from '../helpers/CallbackHelpers';
import {Func} from '../types/Func';
import {Assessee} from '../types/Assessee';
import {AssesseeFilter} from '../types/AssesseeFilter';

export interface AssesseeCacheProps {
  getAssessees: (filter: AssesseeFilter) => Assessee[];
  clearAssesseeCache: Func;
  isAssesseeCacheProcessing: boolean;
}

export const AssesseeCache = React.createContext<AssesseeCacheProps>({
  getAssessees: CallbackHelpers.ThrowNotImplemented,
  clearAssesseeCache: CallbackHelpers.NoOp,
  isAssesseeCacheProcessing: false
});
